import { registerIconAsWebComponent, setTheme, IconWebCmpAttrs } from '@etna-trader/etna-ui';

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'etna-icon': IconWebCmpAttrs;
            // 'acat-number-input': NumberInputWebCmpAttrs
        }
    }
}

export const initEtnaUi = (theme: 'light' | 'dark'): void => {
    const prefix = 'etna'; // start prefix of registered web-component
    // const prefix = 'icon'; // start prefix of registered web-component

    setTheme(theme);
    registerIconAsWebComponent(prefix);
};
